import { render, staticRenderFns } from "./order.vue?vue&type=template&id=7f34ebb6&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=7f34ebb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f34ebb6",
  null
  
)

export default component.exports